module.exports = __webpack_public_path__ + "static/options_google_calendar-ec3a14a327e7b6530c34a57daf536099.png";